import { MenuItem, styled } from '@mui/material';

const StyledMenuItem = styled(MenuItem)``;

export default StyledMenuItem;
